import { DEFAULT_PAYMENT_TYPE, INCENTIVE } from './paymentRequestTypes';
import type {
  AwardPaymentRequestApiDetails,
  AwardPaymentRequestContentInitialState,
  ExistingUploadedDocumentsByDocumentId,
} from './AwardPaymentRequestContent.types';

const toAwardType = (awardType?: string) => (awardType === INCENTIVE ? INCENTIVE : DEFAULT_PAYMENT_TYPE);

const mapExistingDocumentsByDocumentId = (documents: AwardPaymentRequestApiDetails['documents']): ExistingUploadedDocumentsByDocumentId => {
  if (!documents?.length) {
    return {};
  }

  return documents.reduce<ExistingUploadedDocumentsByDocumentId>((accumulator, document) => {
    const existingFiles = accumulator[document.document_id] ?? [];
    accumulator[document.document_id] = [
      ...existingFiles,
      {
        id: document.id,
        documentId: document.document_id,
        originalFileName: document.original_file_name,
        contentType: document.content_type,
        fileSizeBytes: document.file_size_bytes,
      },
    ];
    return accumulator;
  }, {});
};

export const mapAwardPaymentRequestDetailsToFormState = (details: AwardPaymentRequestApiDetails): AwardPaymentRequestContentInitialState => ({
  id: details.id,
  userId: details.user_id ?? 0,
  status: details.status ?? '',
  yourInformationState: {
    userId: details.user_id ?? 0,
    firstName: details.first_name ?? '',
    lastName: details.last_name ?? '',
    enrolledInSchool: details.enrolled_in_school ?? '',
    schoolInfo: {
      currentMajor: details.schoolInfo?.current_major ?? '',
      dateOfEnrollment: details.schoolInfo?.date_of_enrollment ?? '',
      plannedGraduationDate: details.schoolInfo?.planned_graduation_date ?? '',
      gpa: details.schoolInfo?.gpa ?? '',
    },
    employmentStatus: details.employment_status ?? '',
    employmentInfo: {
      placeOfEmployment: details.employmentInfo?.place_of_employment ?? '',
      industryTrade: details.employmentInfo?.industry_trade ?? '',
      startDate: details.employmentInfo?.start_date ?? '',
      paySchedule: details.employmentInfo?.pay_schedule ?? '',
      averageHoursWorkedPerWeek: details.employmentInfo?.average_hours_worked_per_week ?? '',
      positionTitle: details.employmentInfo?.position_title ?? '',
    },
  },
  detailsState: {
    paymentRecipient: details.payment_recipient ?? '',
    amountRequested: details.amount_requested ?? '',
    purpose: details.purpose ?? '',
    awardType: toAwardType(details.award_type),
    notes: details.notes ?? '',
    lastDateOfPayStubs: details.last_date_of_pay_stubs ?? '',
  },
  uploadedDocumentsByDocumentId: mapExistingDocumentsByDocumentId(details.documents),
});
